import React, { useState, useEffect, useMemo } from 'react';
import Layout from '../../layout/default';
import { Link } from 'react-router-dom';

import { useNavigate, useParams } from 'react-router-dom';
import { getSubmissionsProfileById } from '../../services/folder/form-avaliable';
import { useAuth } from '../../container/authContext';
import Select from 'react-select';
import { SubmissionItem } from '../../components/library/submission-item';
import { FolderItem } from '../../components/library/folders/folder';
import { Breadcrumbs } from '../../components/library/Breadcrumbs';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { getUserById } from '../../services/user';
import { usePermission } from '../../container/permissionContext';
import { redirectToLibrary } from '../../utility';
import { utcToLocalDateFormatter } from '../../utility/dates/utcToLocalDate';
import ExportStatisticsPanel from './components/ExportStatisticsPanel';

const FORMS_AVAILABLE_TO_ME_LABEL = 'Forms Available To Me';

const flattenBreadcrumbs = (node) => {
  const list = [];
  let cursor = node;
  while (cursor) {
    if (cursor.name !== FORMS_AVAILABLE_TO_ME_LABEL) {
      list.push({ id: cursor.id, name: cursor.name });
    }
    cursor = cursor.children;
  }
  return list;
};

function CorporateLibrary() {
  const { user } = useAuth();
  const [profile, setUser] = useState({});

  const [defaultIndex, setDefaultIndex] = useState(1);
  const [pageBreadcrumbs, setPageBreadcrumbs] = useState([
    {
      url: '/my-profile',
      name: 'My Profile',
    },
  ]);

  const { user_id, id } = useParams();
  const navigation = useNavigate();
  const { isEmployee, hasPermission } = usePermission();
  useEffect(() => {
    if (isEmployee() && !hasPermission('Users, Positions management')) {
      redirectToLibrary(navigation);
    }
  }, [isEmployee, navigation, hasPermission]);
  useEffect(() => {
    initPage();
    // eslint-disable-next-line
  }, [user_id]);
  const initPage = () => {
    getUserById(user_id)
      .then((res) => {
        setUser(res);
        let breadcrumbs = [
          {
            url: `/company/${res.company.id}`,
            name: res.company.name,
          },
          {
            url: `/company/${res.company.id}/users`,
            name: 'User List',
          },
          {
            url: `/company/${res.company.id}/user/${res.id}`,
            name: `${res.first_name} ${res.last_name}`,
          },
          {
            url: `/company/${res.company.id}/user/${res.id}/forms`,
            name: `Forms`,
          },
        ];
        setPageBreadcrumbs(breadcrumbs);
      })
      .catch((e) => console.log(e));
  };
  const [folders, setFolders] = useState([]);
  const [forms, setForms] = useState([]);
  const [folderBreadcrumbs, setFolderBreadcrumbs] = useState([]);
  const [currentFolderId, setCurrentFolderId] = useState(null);
  const [search, setSearch] = useState('');
  const [isFilterMode, setIsFilterMode] = useState(false);
  const [isExportStatisticsOpen, setIsExportStatisticsOpen] = useState(false);
  const [formsWithoutFolders, setFormsWithoutFolders] = useState(false);
  const [filters, setFilters] = useState({
    status: {
      value: 'active',
      label: 'Active',
    },
    form_type: null,
    submitter_type: null,
  });

  useEffect(() => {
    if (profile?.id) {
      fetchFolder(currentFolderId);
    }
    // eslint-disable-next-line
  }, [profile?.id, search, filters, formsWithoutFolders]);

  const clearFilter = () => {
    setSearch('');
    setFilters({
      status: {
        value: 'active',
        label: 'Active',
      },
      form_type: null,
      submitter_type: null,
    });
  };
  const handleFilter = (value, key) => {
    setFilters(() => {
      const prevState = { ...filters };
      prevState[key] = value;
      return prevState;
    });
  };

  const fetchFolder = (folderId) => {
    const bodyRequest = { company_id: id };
    let searchParam = search;
    if (!searchParam && formsWithoutFolders) {
      searchParam = ' ';
    }
    if (searchParam) {
      bodyRequest.search = searchParam;
    }
    if (folderId) {
      bodyRequest.folder_id = folderId;
    }
    if (filters.status) {
      bodyRequest['status'] = filters.status.value;
    }
    if (filters.form_type) {
      bodyRequest['form_type'] = filters.form_type.value;
    }

    getSubmissionsProfileById(user_id, bodyRequest)
      .then((res) => {
        if (searchParam) {
          // Flat list (either search or formsWithoutFolders toggle)
          setFolders([]);
          setForms(Array.isArray(res) ? res : []);
          setFolderBreadcrumbs([]);
          return;
        }
        const data = Array.isArray(res?.data) ? res.data : [];
        setFolders(data.filter((item) => item.type === 'folder'));
        setForms(data.filter((item) => item.type === 'form'));
        const trail = flattenBreadcrumbs(res?.breadcrumbs);
        setFolderBreadcrumbs(trail);
        setCurrentFolderId(trail.length ? trail[trail.length - 1].id : null);
      })
      .catch((e) => console.log(e));
  };

  const changeFolder = (folderId) => {
    setCurrentFolderId(folderId);
    fetchFolder(folderId);
  };

  const goToPrev = (target, type) => {
    if (type === 'folder') {
      changeFolder(target);
    } else {
      changeFolder(null);
    }
  };

  const breadcrumbsItems = useMemo(() => {
    const root = { name: 'Forms', url: 'root' };
    return [root, ...folderBreadcrumbs];
  }, [folderBreadcrumbs]);

  const isEmpty = !folders.length && !forms.length;

  return (
    <Layout breadcrumbs={pageBreadcrumbs} title={'User Profile - Forms'}>
      <div className={`page-wrapper ${profile.deleted_at ? 'page-wrapper-deactivated' : ''}`}>
        <div className="company-profile">
          {profile.first_name && (
            <>
              <div className="company-profile-header">
                <div className="user-profile-header">
                  <div>
                    <span className="date-add">
                      Date Added: {utcToLocalDateFormatter(profile.created_at)}{' '}
                      {profile.deleted_at && (
                        <span className="date-add-deactivated">Deactivated: {utcToLocalDateFormatter(user.deleted_at)}</span>
                      )}
                    </span>
                    <h2 className="company-profile-title">
                      {profile.last_name} {profile.first_name}
                    </h2>
                    <h3 className="company-profile-subtitle">{profile.role}</h3>
                  </div>
                </div>
                <div className="company-profile-header-action"></div>
              </div>
              <div className="company-profile-tab user-profile-tab">
                <Tabs selectedIndex={defaultIndex} onSelect={(index) => setDefaultIndex(index)}>
                  <TabList>
                    <Tab onClick={() => navigation(`/company/${id}/user/${user_id}`)}>Main Information</Tab>
                    <Tab>Forms</Tab>
                    <Tab onClick={() => navigation(`/company/${id}/users/${user_id}/related-files`)}>Related Files</Tab>
                  </TabList>
                  <TabPanel>
                    <h3>Main Information</h3>
                  </TabPanel>
                  <TabPanel>
                    <DndProvider backend={HTML5Backend}>
                    <div className="library p-0">
                      {!search && folderBreadcrumbs.length > 0 && (
                        <Breadcrumbs breadcrumbs={breadcrumbsItems} goToLevel={goToPrev} />
                      )}
                      <div className="library-filter">
                        <div className="library-filter-search form-control-item">
                          <input
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                            type="text"
                            className="form-control"
                            placeholder="Search"
                          />
                          <i className="icon-search"></i>
                        </div>
                        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                          <button
                            className={`btn-outline btn ${isFilterMode ? 'btn-active' : ''}`}
                            style={{ height: 44, width: 44 }}
                            onClick={() => setIsFilterMode(!isFilterMode)}
                          >
                            <i className="icon-icon-sliders"></i>
                          </button>
                          <button
                            className={`btn-outline btn`}
                            style={{ height: 44, width: 44 }}
                            onClick={() => setFormsWithoutFolders((prevState) => !prevState)}
                          >
                            {!formsWithoutFolders ? (
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path
                                  d="M2.50033 4.16797C2.04009 4.16797 1.66699 4.54106 1.66699 5.0013C1.66699 5.46154 2.04009 5.83464 2.50033 5.83464H2.50866C2.9689 5.83464 3.34199 5.46154 3.34199 5.0013C3.34199 4.54106 2.9689 4.16797 2.50866 4.16797H2.50033Z"
                                  fill="#101828"
                                />
                                <path
                                  d="M6.66699 4.16797C6.20676 4.16797 5.83366 4.54106 5.83366 5.0013C5.83366 5.46154 6.20676 5.83464 6.66699 5.83464H17.5003C17.9606 5.83464 18.3337 5.46154 18.3337 5.0013C18.3337 4.54106 17.9606 4.16797 17.5003 4.16797H6.66699Z"
                                  fill="#101828"
                                />
                                <path
                                  d="M6.66699 9.16797C6.20676 9.16797 5.83366 9.54106 5.83366 10.0013C5.83366 10.4615 6.20676 10.8346 6.66699 10.8346H17.5003C17.9606 10.8346 18.3337 10.4615 18.3337 10.0013C18.3337 9.54106 17.9606 9.16797 17.5003 9.16797H6.66699Z"
                                  fill="#101828"
                                />
                                <path
                                  d="M5.83366 15.0013C5.83366 14.5411 6.20676 14.168 6.66699 14.168H17.5003C17.9606 14.168 18.3337 14.5411 18.3337 15.0013C18.3337 15.4615 17.9606 15.8346 17.5003 15.8346H6.66699C6.20676 15.8346 5.83366 15.4615 5.83366 15.0013Z"
                                  fill="#101828"
                                />
                                <path
                                  d="M1.66699 10.0013C1.66699 9.54106 2.04009 9.16797 2.50033 9.16797H2.50866C2.9689 9.16797 3.34199 9.54106 3.34199 10.0013C3.34199 10.4615 2.9689 10.8346 2.50866 10.8346H2.50033C2.04009 10.8346 1.66699 10.4615 1.66699 10.0013Z"
                                  fill="#101828"
                                />
                                <path
                                  d="M2.50033 14.168C2.04009 14.168 1.66699 14.5411 1.66699 15.0013C1.66699 15.4615 2.04009 15.8346 2.50033 15.8346H2.50866C2.9689 15.8346 3.34199 15.4615 3.34199 15.0013C3.34199 14.5411 2.9689 14.168 2.50866 14.168H2.50033Z"
                                  fill="#101828"
                                />
                              </svg>
                            ) : (
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path
                                  d="M8.44444 3H3V8.44444H8.44444V3Z"
                                  stroke="#101828"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M17 3H11.5556V8.44444H17V3Z"
                                  stroke="#101828"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M17 11.5556H11.5556V17H17V11.5556Z"
                                  stroke="#101828"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M8.44444 11.5556H3V17H8.44444V11.5556Z"
                                  stroke="#101828"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            )}
                          </button>
                        </div>
                        <Link to={`/company/${id}/users/${user_id}/export-submissions`}>
                          <button disabled={!forms?.length && !folders?.length} className="btn" onClick={() => {}}>
                            Export to PDF
                          </button>
                        </Link>
                        <button
                          className="btn"
                          style={{ marginLeft: 8 }}
                          onClick={() => setIsExportStatisticsOpen(true)}
                        >
                          Export Statistics
                        </button>
                      </div>
                      {isFilterMode && (
                        <div className="library-filters">
                          <div className="library-filters-wrapper">
                            <div className="form-item">
                              <label className="form-label">Status</label>
                              <Select
                                options={[
                                  {
                                    value: 'all',
                                    label: 'All',
                                  },
                                  {
                                    value: 'active',
                                    label: 'Active',
                                  },
                                  {
                                    value: 'archived',
                                    label: 'Archived',
                                  },
                                ]}
                                value={filters.status}
                                onChange={(e) => handleFilter(e, 'status')}
                                className="form-control-select"
                                classNamePrefix="react-select"
                              ></Select>
                            </div>
                          </div>

                          <button className="btn btn-outline" onClick={clearFilter}>
                            Clear All
                          </button>
                        </div>
                      )}

                      <>
                        {!isEmpty && (
                          <>
                            <div
                              style={{
                                color: '#555F72',
                                fontSize: 14,
                                borderBottom: '1px solid #DADEE4',
                                padding: '5px 0 15px 15px',
                                fontWeight: 500,
                              }}
                            >
                              Name
                            </div>
                            <div className="library-wrapper" style={{ rowGap: 0 }}>
                              {folders.map((item) => (
                                <FolderItem key={`folder-${item.id}`} item={item} isListItem changeFolder={changeFolder} />
                              ))}
                              {forms.map((item) => (
                                <SubmissionItem
                                  isListItem
                                  key={`form-${item.id}`}
                                  url={`/company/${id}/user/${user_id}/forms/${item.id}`}
                                  item={item}
                                />
                              ))}
                            </div>
                          </>
                        )}
                        {isEmpty && !!search && (
                          <div className="empty-page">
                            <h3 className="empty-page-title">Unfortunately, nothing was found for your query.</h3>
                            <h4 className="empty-page-subtitle">
                              Try to change the range of keywords. We're here to help you find what you're looking for.
                            </h4>
                          </div>
                        )}
                        {isEmpty && !search && (
                          <div className="empty-page">
                            <h3 className="empty-page-title">This folder is empty</h3>
                            <h4 className="empty-page-subtitle">This folder currently does not contain any forms. </h4>
                          </div>
                        )}
                      </>
                    </div>
                    </DndProvider>
                    <ExportStatisticsPanel
                      isOpen={isExportStatisticsOpen}
                      onClose={() => setIsExportStatisticsOpen(false)}
                      userID={user_id}
                    />
                  </TabPanel>
                </Tabs>
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default CorporateLibrary;
